export default [
  {
    text: 'Mês/Ano',
    value: 'ano',
    style: {
      width: '90px',
      borderRight: '1px solid rgba(0,0,0,.1)'
    }
  },
  {
    text: 'Pedidos',
    value: 'pedidos_em_valor'
  },
  {
    text: 'Entregue',
    value: 'entregue_em_valor'
  },
  {
    text: 'Pendente',
    style: {
      borderRight: '1px solid rgba(0,0,0,.1)'
    },
    value: 'pendente_em_valor'
  },
  {
    text: 'Skus c/ estoque',
    value: 'sku_com_estoque'
  },
  {
    text: 'Estoque (R$)',
    value: 'valor_estoque'
  },
  {
    text: 'Qtde sku excesso',
    value: 'sku_excesso'
  },
  {
    text: 'Excesso (R$)',
    value: 'valor_excesso'
  },
  {
    text: 'Excesso (%)',
    value: 'porcentagem_excesso'
  },
  {
    text: 'Faturamento',
    style: {
      borderRight: '1px solid rgba(0,0,0,.1)'
    },
    value: 'faturamento',
  },
  {
    text: 'Zerados',
    value: 'sku_zerado'
  },
  {
    text: 'Valor',
    value: 'valor_ruptura'
  },
  {
    text: '%',
    value: 'porcentagem_ruptura',
    style: {
      borderRight: '1px solid rgba(0,0,0,.1)'
    }
  },
  {
    text: 'Valor',
    value: 'valor_saving'
  },
  {
    text: '%',
    value: 'porcentagem_saving',
    style: {
      borderRight: '1px solid rgba(0,0,0,.1)'
    }
  },
  {
    text: 'Ruptura',
    value: 'porcentagem_ruptura'
  },
  {
    text: 'Exposto',
    value: 'porcentagem_exposto'
  },
  {
    text: 'Ponto pedido',
    value: 'porcentagem_ponto_pedido'
  },
  {
    text: 'Prematuro',
    value: 'porcentagem_prematuridade'
  },
  {
    text: 'Sem comportamento',
    value: 'porcentagem_sem_comportamento'
  },
]
